import {Observable} from 'rxjs';
import {SelectableEntity} from '../entity/selectable-entity';

export class TvaSettings {
  public countries: Observable<SelectableEntity[]>;
  public checkRequest: string;

  constructor(checkRequest?: string, countries?: Observable<SelectableEntity[]>) {
    this.checkRequest = checkRequest;
    this.countries = countries;
  }
}
